var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQobuzColorLightPadding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 50,
    viewBox: "0 0 200 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Qobuz"
  }, /*#__PURE__*/React.createElement("g", {
    id: "qobuz-color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Qobuz_logotype"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 56.673,
    cy: 24.9459,
    r: 12.673,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.467 24.945C46.467 19.309 51.036 14.739 56.673 14.739C62.31 14.739 66.879 19.308 66.879 24.945C66.879 30.582 62.309 35.152 56.673 35.152C51.037 35.152 46.467 30.581 46.467 24.945ZM52.658 24.945C52.658 27.162 54.456 28.96 56.673 28.96C58.891 28.96 60.688 27.163 60.688 24.945C60.688 22.728 58.89 20.93 56.673 20.93C54.456 20.93 52.658 22.728 52.658 24.945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_2",
    cx: 56.673,
    cy: 24.946,
    r: 0.871,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M51.793 24.7379C51.902 22.1359 54.045 20.0599 56.673 20.0599C59.301 20.0599 61.445 22.1359 61.553 24.7379H66.1C65.989 19.6249 61.813 15.5129 56.673 15.5129C51.533 15.5129 47.356 19.6249 47.246 24.7379H51.793Z",
    fill: "url(#paint0_linear_107_358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M56.673 15.5149V20.0619C59.302 20.0949 61.492 22.2039 61.556 24.8259H66.103C66.039 19.6929 61.814 15.5479 56.673 15.5149Z",
    fill: "url(#paint1_linear_107_358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M56.673 15.5149V20.0619C54.044 20.0949 51.856 22.2039 51.793 24.8259H47.246C47.31 19.6929 51.533 15.5479 56.673 15.5149Z",
    fill: "url(#paint2_linear_107_358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M63.395 32.623C61.599 34.196 59.249 35.152 56.674 35.152C56.664 35.152 56.654 35.151 56.644 35.151V37.618C56.654 37.618 56.664 37.619 56.674 37.619C59.868 37.619 62.784 36.435 65.013 34.485C64.478 33.859 63.921 33.253 63.395 32.623Z",
    fill: "url(#paint3_linear_107_358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M69.201 36.0281L62.364 29.1761C62.162 28.9091 61.843 28.7351 61.483 28.7351C60.873 28.7351 60.379 29.2291 60.379 29.8391C60.379 30.1361 60.497 30.4051 60.688 30.6041C60.701 30.6171 60.714 30.6301 60.728 30.6431L67.695 37.4551L69.201 36.0281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.288 25.0001C95.288 20.7351 98.746 17.2771 103.011 17.2771C107.276 17.2771 110.734 20.7351 110.734 25.0001C110.734 29.2651 107.276 32.7231 103.011 32.7231C98.746 32.7231 95.288 29.2651 95.288 25.0001ZM97.933 25.0001C97.933 27.8051 100.207 30.0781 103.011 30.0781C105.815 30.0781 108.089 27.8041 108.089 25.0001C108.089 22.1951 105.815 19.9221 103.011 19.9221C100.206 19.9221 97.933 22.1961 97.933 25.0001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M85.943 17.2771C81.678 17.2771 78.22 20.7351 78.22 25.0001C78.22 29.2651 81.678 32.7231 85.943 32.7231C87.409 32.7231 88.78 32.3141 89.948 31.6051V28.1201C89.019 29.3111 87.571 30.0781 85.943 30.0781C83.139 30.0781 80.865 27.8051 80.865 25.0001C80.865 22.1961 83.138 19.9221 85.943 19.9221C88.747 19.9221 91.021 22.1951 91.021 25.0001V30.8161V38.9421C91.021 39.6721 91.613 40.2641 92.343 40.2641C93.073 40.2641 93.665 39.6721 93.665 38.9421V25.0001C93.666 20.7351 90.209 17.2771 85.943 17.2771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M120.041 32.7231C124.306 32.7231 127.764 29.2651 127.764 25.0001C127.764 20.7351 124.306 17.2771 120.041 17.2771C118.575 17.2771 117.204 17.6861 116.036 18.3951V21.8801C116.965 20.6891 118.413 19.9221 120.041 19.9221C122.845 19.9221 125.119 22.1951 125.119 25.0001C125.119 27.8041 122.846 30.0781 120.041 30.0781C117.237 30.0781 114.963 27.8051 114.963 25.0001V19.1841V11.0581C114.963 10.3281 114.371 9.73608 113.641 9.73608C112.911 9.73608 112.319 10.3281 112.319 11.0581V25.0001C112.318 29.2651 115.776 32.7231 120.041 32.7231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M135.892 32.7231C131.569 32.7231 129.51 28.8561 129.51 26.8721C129.51 24.8881 129.51 18.6001 129.51 18.6001C129.51 17.8701 130.102 17.2781 130.833 17.2781C131.563 17.2781 132.155 17.8701 132.155 18.6001C132.155 18.6001 132.155 25.6741 132.155 26.5731C132.155 27.4721 132.392 30.0791 135.985 30.0791C138.979 30.0791 139.628 28.1081 139.628 27.0971C139.628 26.0861 139.628 18.6001 139.628 18.6001C139.628 17.8701 140.22 17.2781 140.951 17.2781C141.681 17.2781 142.273 17.8701 142.273 18.6001C142.273 18.6001 142.273 25.4121 142.273 27.0221C142.274 28.6311 140.777 32.7231 135.892 32.7231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M153.684 32.7231C154.411 32.7231 155 32.1341 155 31.4071C155 30.6801 154.411 30.0911 153.684 30.0911H147.477L152.829 22.8681C154.925 20.0611 155 19.9491 155 19.1631C155 18.2651 154.102 17.3911 153.203 17.3911C152.305 17.3911 145.387 17.3911 145.387 17.3911C144.66 17.3911 144.071 17.9801 144.071 18.7071C144.071 19.4341 144.66 20.0231 145.387 20.0231H151.781C151.781 20.0231 144.969 29.0061 144.37 29.8291C143.771 30.6521 144.108 32.7231 145.717 32.7231C147.326 32.7231 153.684 32.7231 153.684 32.7231Z",
    fill: "black"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_358",
    x1: 47.2462,
    y1: 24.7382,
    x2: 66.1008,
    y2: 24.7382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8763
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_358",
    x1: 53.1166,
    y1: 19.9109,
    x2: 60.4265,
    y2: 26.4457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#B5B5B5",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1244,
    stopColor: "#969696",
    stopOpacity: 0.1632
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5553,
    stopColor: "#2B2B2B",
    stopOpacity: 0.7421
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7473
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_107_358",
    x1: 53.7074,
    y1: 12.6119,
    x2: 46.3963,
    y2: 19.1437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#B5B5B5",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1244,
    stopColor: "#969696",
    stopOpacity: 0.1632
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5553,
    stopColor: "#2B2B2B",
    stopOpacity: 0.7421
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7473
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_107_358",
    x1: 61.8007,
    y1: 38.9642,
    x2: 65.2224,
    y2: 32.4241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#B5B5B5",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0486,
    stopColor: "#A8A8A8",
    stopOpacity: 0.0514
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2682,
    stopColor: "#6C6C6C",
    stopOpacity: 0.2982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4701,
    stopColor: "#3E3E3E",
    stopOpacity: 0.5252
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6478,
    stopColor: "#1C1C1C",
    stopOpacity: 0.725
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7947,
    stopColor: "#070707",
    stopOpacity: 0.8901
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8925
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQobuzColorLightPadding);
export default __webpack_public_path__ + "static/media/qobuz-color-light-padding.b341cd7a9de6f4b57698423473c461d4.svg";
export { ForwardRef as ReactComponent };